import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { TruncateModule } from '@pipes/truncate-pipe/turncate.module';
import { PipeDirectiveModule } from '@shared-modules/pipe-directive.module';
import { TooltipModule } from 'primeng/tooltip';
import { ReMultipleSelectComponent } from './re-multi-select.component';
import { FilterPipeModule } from '@pipes/filter-pipe/filter.module';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
  imports: [CommonModule, NgSelectModule, FormsModule, TruncateModule, PipeDirectiveModule, TooltipModule, FilterPipeModule, InputSwitchModule],
  declarations: [ReMultipleSelectComponent],
  exports: [ReMultipleSelectComponent],
  providers: [DatePipe],
})
export class ReMultipleSelectModule {}
